import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';

import {TranslateService} from '@ngx-translate/core';

import groupBy from 'lodash-es/groupBy';

import {DATE_MAX} from '../../../app.constants';
import {EmpContractAttributes} from '../../../models/models.interfaces';
import {Data} from '../../api/server-responses.interfaces';
import {ContractStatus} from '../../employees/contract/contract.interfaces';
import {DateLocalizationPipe} from '../../pipes/date-localization.pipe';

@Component({
  selector: 'gp-contract-switcher',
  templateUrl: './contract-switcher.component.html',
  styleUrls: ['./contract-switcher.component.scss']
})
export class ContractSwitcherComponent implements OnChanges {

  @Output() public onSelectContract = new EventEmitter<EmpContractAttributes>();
  @Input() contracts: EmpContractAttributes[];
  @Input() selectedContract: Data<EmpContractAttributes>;
  public regroupedContracts: { [key: string]: EmpContractAttributes[] } = {};

  public get contractStatuses() {
    return Object.keys(this.regroupedContracts);
  }


  public isInactiveContract(contract: EmpContractAttributes): boolean {
    return contract.status === ContractStatus.INACTIVE;
  }

  constructor(private translate: TranslateService,
              private dateLocalizationPipe: DateLocalizationPipe) {
    this.customPlaceholderGenerator = this.customPlaceholderGenerator.bind(this);
  }

  public customPlaceholderGenerator(contract: EmpContractAttributes) {
    const text: string = this.translate.instant('EMPLOYEE_FORM.Contract_name', {
      name: contract.cliRegNickName
    });
    return (contract.flag ? `<img class="flag-icon" src="${contract.flag.href}" />` : '') +
      `<span class="switch-contract-regulation">${text}</span> <span class="switch-contract-dates">${this.getContractDate(contract)}</span> <span class="contract-status ${contract.status.toLowerCase()}"></span>`;
  }

  public getContractDate(contract: EmpContractAttributes): string {
    return `(${
      this.dateLocalizationPipe.transform(contract.begindate)
    } - ${
      contract.enddate === DATE_MAX || !contract.enddate
        ? '...'
        : this.dateLocalizationPipe.transform(contract.enddate)
    })`;
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.contracts) {
      this.regroupedContracts = groupBy(this.contracts, (contract: EmpContractAttributes) => contract.status);
    }
  }
}
